import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Inv1140GetResultModel, Inv1140GetResultSchema } from './get.schema'

export async function fetchInv1140(id: number): Promise<Inv1140GetResultModel> {
  const response = await axios.get<Inv1140GetResultModel>(
    `/api/warehouse/inv1140/${id}`
  )
  return Inv1140GetResultSchema.parse(response.data)
}

export const getInv1140ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['inv1140', id],
    queryFn: () => fetchInv1140(id),
  })
